import React from 'react';

export interface ABlockquoteProps extends React.HTMLAttributes<HTMLQuoteElement> {
  text?: string;
}
